import styled from "styled-components";

export const Table = styled.table`
  width: 100%;
  padding-bottom: 1em;
`;
export const Cell = styled.div`
  border-radius: 0.3em;
  padding: 0.5em;
  margin: 0.2em 0.5em;
  min-height: 1em;
  max-height: 1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
`;

export const HeaderCell = styled(Cell)`
  font-weight: bold;
`;

export const PlayerCell = styled(Cell)`
  color: var(--color-text-light);
  text-align: start;
  padding-right: 0px;
  margin-right: 0px;
  padding-left: 0px;
  margin-left: 0px;
`;
